import {ConcreteContext} from "./ConcreteContext";
import {Dispatch} from "react";

export class PathwayContext extends ConcreteContext {
    public constructor(dispatch: Dispatch<any>) {
        super(dispatch);
    }

    pushComment = (project: string, value: unknown) =>
        this.push(`comments/${project}`, value);
    pushCommentReply = (project: string, comment: string, value: unknown) =>
        this.push(`comments/${project}/${comment}/replies`, value);
    pushIgnoreGrammar = (project: string, state: string, value: unknown) =>
        this.push(`ignoredGrammar/${project}/${state}`, value);
    pushNotification = (user: string, details: unknown) =>
        this.push(`notifications/${user}`, {timestamp: Date.now(), details});
    pushState = (project: string, value: unknown) =>
        this.push(`networks/${project}/states`, value);
    removeInvite = (invite: string) =>
        this.remove(`invites/${invite}`);
    removeLock = (project: string, state: string) =>
        this.remove(`locks/${project}/${state}`);
    removeNetwork = (project: string) =>
        this.remove(`networks/${project}`);
    removeRegister = (project: string, register: string) =>
        this.remove(`networks/${project}/registers/${register}`);
    removeState = (project: string, state: string) =>
        this.remove(`networks/${project}/states/${state}`);
    setCommentMember = (project: string, commentId: string, member: unknown, value: unknown) =>
        this.set(`comments/${project}/${commentId}/${member}`, value);
    setCommentReplyMember = (project: string, commentId: string, reply: string, member: unknown, value: unknown) =>
        this.set(`comments/${project}/${commentId}/replies/${reply}/${member}`, value);
    setDictionaryEntry = (project: string, user: string, value: string) =>
        this.set(`dictionaries/${project}/${value}`, {user, date: Date.now()});
    setGrammar = (project: string, state: string, value: unknown) =>
        this.set(`grammar/${project}/${state}`, value);
    setLock = (project: string, state: string, user: string) =>
        this.set(`locks/${project}/${state}`, {user, created: Math.floor(Date.now() / 1000)});
    setNetworkMember = (project: string, member: string, value: unknown) =>
        this.set(`networks/${project}/${member}`, value);
    setProjectMember = (project: string, member: string, value: unknown) =>
        this.set(`projects/${project}/${member}`, value);
    setRegister = (project: string, register: string, value: unknown) =>
        this.set(`networks/${project}/registers/${register}`, value);
    setStateMember = (project: string, state: string, member: string, value: unknown) =>
        this.set(`networks/${project}/states/${state}/${member}`, value);
    setStatePosition = (project: string, state: string, value: unknown)=>
        Promise.resolve();
    setStateTransitionMember = (project: string, state: string, transition: number, member: string, value: unknown) =>
        this.set(`networks/${project}/states/${state}/transitions/${transition}/${member}`, value);
    setUserMember = (user: string, member: string, value: unknown) =>
        this.set(`users/${user}/${member}`, value);
    trackComments = (project: string) => 
        this.track(`comments/${project}`, ["comments"]);
    trackDictionary = (project: string) => 
        this.track(`dictionaries/${project}`, ["dictionary"]);
    trackGrammar = (network: string) =>
        this.track(`grammar/${network}`, ["grammar"]);
    trackSheets = (project: string) =>
        this.track(`sheets/${project}`, ["sheets"]);
    trackInvites = () => 
        this.track("invites");
    trackIgnoredGrammar = (network: string) =>
        this.track(`ignoredGrammar/${network}`, ["ignoredGrammar"]);
    trackNetwork = (network: string) => {
        this.track(`networks/${network}`, ["network"]);
        this.track(`constants/${network}`, ["constants"]);
        this.track(`tags/${network}`, ["tags"]);
    }
    trackUser = (user: string) =>
        this.track(`users/${user}`, ["user"]);
    trackUsers = () =>
        this.track("users");
    untrackNetwork = (network: string) => {
        this.untrack(`networks/${network}`);
        this.untrack(`constants/${network}`);
        this.untrack(`tags/${network}`);
    }
    untrackUser = (user: string) => 
        this.untrack(`users/${user}`);
}
